"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDetail = void 0;
var ErrorDetail;
(function (ErrorDetail) {
    ErrorDetail["FETCH_ERROR"] = "fetchError";
    // identifier for adapter script load error
    ErrorDetail["SCRIPT_LOAD_ERROR"] = "scriptLoadError";
    ErrorDetail["SEEK_ERROR"] = "seekError";
    ErrorDetail["AVPLAYER_INIT_ERROR"] = "avplayerInitError";
})(ErrorDetail = exports.ErrorDetail || (exports.ErrorDetail = {}));
//# sourceMappingURL=errorDetail.js.map